import React from 'react'
import styled from 'styled-components'

const Paragraph = styled.p`
  display: flex;
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.7px;
  margin: 16px 0px 24px 0px;
  color: #8b8b8b;
  white-space: nowrap;
  align-items: center;
  span {
    margin: 0 16px;
  }
  &:before,
  &:after {
    content: '';
    width: 100%;
    border-bottom: solid 1px rgba(31, 31, 31, 0.2);
  }
`
const Separator = ({ children }) => (
  <Paragraph className="u-pt-16 u-mb-32">
    {children ? <span>{children}</span> : null}
  </Paragraph>
)

export default Separator



// WEBPACK FOOTER //
// ./src/components/Separator/Separator.js